'use strict';

const isConstructor = require('./isConstructor');

/**
 * Returns true if the given subCls would instantiate an instance
 * of cls. Avoids execution of either constructors.
 *
 * @example
 *   isSubclassOf(Function, Object); // => true
 *   isSubclassOf(Array, Array); // => true
 *   isSubclassOf(Object, Array); // => false
 *   isSubclassOf([], Array); // => false
 *
 * @param  {*}  subCls a constructor function
 * @param  {Function}  cls    another constructor function
 * @return {Boolean}
 */
module.exports = function isSubclassOf (subCls, cls) {
  if (!isConstructor(subCls)) {
    return false;
  }
  if (!isConstructor(cls)) {
    throw new Error(`Reference class ${cls} for isSubclassOf check is not a constructor function!`);
  }


  if (subCls === cls) {
    return true;
  } else {
    return subCls.prototype instanceof cls;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-type-utils/isSubclassOf.js